import { BoardBackend } from '../../../../frontend/src/app/core/board/board';
import {
  HourlyTask,
  TempUser,
  WorkspaceComboBackend,
  WorkspaceItemType,
} from '../../../../frontend/src/app/core/workspace/workspace';
import { BasicAction } from '../basic-action';
import { SuccessResponse } from '../request-response';
import { ResourceName } from '../resource-name';

// tslint:disable: variable-name
export const WorkspaceGate = {
  resource: ResourceName.workspace,
  actions: {
    add: BasicAction.add,
    addUserListToWorkspace: 'add-user-list-to-workspace',
    addTempUser: 'add-temp-user',

    leaveWorkspace: 'leave-workspace',
    getMyWorkspaceList: 'get-my-workspace-list',

    getWorkspaceItemListByItemType: 'get-workspace-item-list-by-item-type',

    update: BasicAction.update,
    updateHourlyTaskList: 'update-hourly-task-list',

    changeDefault: 'change-default',
    deleteWorkspace: 'delete-workspace',
    resendEmail: 'resend-email',
    getParentWorkspaceDetail: 'get-parent-workspace-detail',
    getChildWorkspaceList: 'get-child-workspace-list',
    approveChildWorkspace: 'approve-parent-workspace',
    setParentWorkspace: 'set-parent-workspace',
    withdrawChildWorkspace: 'withdraw-child-workspace',
    addPendingHourlyTaskList: 'add-pending-hosurly-task-list',
    removePendingHourlyTaskList: 'remove-pendingHourlyTaskList',
    deleteOpenAiFile: 'delete-openai-file',

    updateHubSpot: 'update-hubspot',

    sendWeeklyReport: 'send-weekly-report',
  },
};

export type WorkspaceGateActionTypes = {
  add: {
    request: WorkspaceComboBackend;
    response: WorkspaceComboBackend;
  };
  leaveWorkspace: {
    request: LeaveWorkspaceRequest;
    response: SuccessResponse;
  };
  addUserListToWorkspace: {
    request: AddUserListToWorkspaceRequest;
    response: AddUserListToWorkspaceResponse;
  };
  addTempUser: {
    request: TempUser;
    response: TempUser;
  };
  getMyWorkspaceList: {
    request: undefined;
    response: WorkspaceComboBackend[];
  };
  getWorkspaceItemListByItemType: {
    request: GetWorkspaceItemListByItemTypeRequest;
    response: any;
  };
  update: {
    request: WorkspaceComboBackend;
    response: WorkspaceComboBackend;
  };
  updateHourlyTaskList: {
    request: WorkspaceComboBackend;
    response: WorkspaceComboBackend;
  };
  changeDefault: {
    request: { workspaceId: string };
    response: SuccessResponse;
  };
  deleteWorkspace: {
    request: string;
    response: undefined;
  };
  resendEmail: {
    request: ResendEmailRequest;
    response: SuccessResponse;
  };
  getParentWorkspaceDetail: {
    request: ByWorkspaceIdRequest;
    response: WorkspaceComboBackend;
  };
  getChildWorkspaceList: {
    request: ByWorkspaceIdRequest;
    response: GetChildWorkspaceListResponse;
  };
  approveChildWorkspace: {
    request: ApproveChildWorkspaceRequest;
    response: SuccessResponse;
  };
  setParentWorkspace: {
    request: SetParentWorkspaceRequest;
    response: SuccessResponse;
  };
  withdrawChildWorkspace: {
    request: WithdrawChildWorkspaceRequest;
    response: SuccessResponse;
  };
  addPendingHourlyTaskList: {
    request: WorkspaceComboBackend;
    response: WorkspaceComboBackend;
  };
  removePendingHourlyTaskList: {
    request: WorkspaceComboBackend;
    response: WorkspaceComboBackend;
  };
  deleteOpenAiFile: {
    request: DeleteOpenAiFileRequest;
    response: any;
  };

  updateHubSpot: {
    request: UpdateHubSpotRequest;
    response: any;
  };
  sendWeeklyReport: {
    request: SendWeeklyReportRequest;
    response: SuccessResponse;
  };
};

export interface SendWeeklyReportRequest {
  workspaceId: string;
  hourlyTask: HourlyTask;
}

export interface UpdateHubSpotRequest {
  hubSpotAccessToken: string;
  workspaceId: string;
}

export interface GetWorkspaceItemListByItemTypeRequest {
  workspaceId: string;
  itemType: WorkspaceItemType;
}

export interface DeleteOpenAiFileRequest {
  workspaceId: string;
  fileId: string;
}

export interface WithdrawChildWorkspaceRequest {
  childWorkspaceId: string;
}

export interface SetParentWorkspaceRequest {
  workspaceId: string;
  parentId: string;
}

export interface LeaveWorkspaceRequest {
  workspaceId: string;
}

export interface ApproveChildWorkspaceRequest {
  myWorkspaceId: string;
  childWorkspaceId: string;
  isApproved: boolean;
}

export interface ChildWorkspaceBackend {
  id: string;
  title: string;
  isApprovedParentId?: boolean;
}

export interface GetChildWorkspaceListResponse {
  childWorkspaceBackendList: ChildWorkspaceBackend[];
}

export interface ByWorkspaceIdRequest {
  workspaceId: string;
}

export interface ResendEmailRequest {
  email: string;
  token: string;
  workspaceId: string;
}

export interface AddUserListToWorkspaceRequest {
  userList: {
    id?: string;
    email: string;
    token?: string;
  }[];
  workspaceId: string;
}

export interface AddUserListToWorkspaceResponse {
  workspaceRelation: {
    addedItemList: WorkspaceComboBackend[];
    deletedItemList: WorkspaceComboBackend[];
  };
  addedBoardList: BoardBackend[];
  updatedWorkspace: WorkspaceComboBackend;
}
